import confirmItemActionAllowed from '../utils/confirmItemActionAllowed';
import getLatestNonDraftItemIdFromConversation from '../utils/getLatestNonDraftItemIdFromConversation';
import { ClientItemId } from 'owa-client-ids';
import { onPrintRow } from 'owa-mail-module-orchestrator';
import { lazyPrint } from 'owa-mail-reading-pane-store';
import { ActionSource } from 'owa-analytics-actions';
import IRMRestrictions from 'owa-mail-store/lib/store/schema/IRMRestrictions';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-mail-strings';
import { action } from 'satcheljs/lib/legacy';

export default action('printConversation')(async function printConversation(
    conversationId: ClientItemId,
    actionSource: ActionSource
) {
    const latestNonDraftItemId = await getLatestNonDraftItemIdFromConversation(conversationId);
    if (latestNonDraftItemId && latestNonDraftItemId.Id) {
        const restrictionToConfirm = <IRMRestrictions>{ PrintAllowed: true };
        if (
            confirmItemActionAllowed(
                latestNonDraftItemId.Id,
                restrictionToConfirm,
                format(strings.irm_actionNotAllowedOnThisConversation, strings.itemHeaderPrint)
            )
        ) {
            lazyPrint.importAndExecute(latestNonDraftItemId, actionSource);
            onPrintRow();
        }
    }
});
